import { Card } from '@pmi/dsm-react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { accountSelector } from '../../../shared/store/shared/accountSlice';
import { useGetDealsListQuery } from '../../../shared/store/shared/dealsApiSlice';
import AccessRulesList from './AccessRulesList';
import styles from './access-rules.module.scss';

export default function AccessRules() {
  const { currentAccountId } = useSelector(accountSelector);
  const { data: dealList, isLoading } = useGetDealsListQuery(currentAccountId);

  if (isLoading) {
    return (
      <div className="col-12">
        <div className="d-block ps-3">
          <Spinner />
        </div>
      </div>
    );
  }
  // Filter deals where isPayByUser is true
  const payByUserDeals = dealList?.filter((deal) => deal.isPayByUser) || [];

  return (
    <div className={styles.accessRulesContainer}>
      <Card className="p-4">
        <div className="mb-3">
          <div className={styles.header}>Edit agreement domain access</div>
          <div className={styles.description}>
            Edit domains access for users within an agreement, changes are
            applied when you save.
          </div>
        </div>

        {payByUserDeals.length > 0 ? (
          payByUserDeals.map((deal) => (
            <AccessRulesList key={deal.id} deal={deal} />
          ))
        ) : (
          <div className="text-muted">
            No deals available with Pay By User enabled.
          </div>
        )}
      </Card>
    </div>
  );
}
